import React, { useContext, isValidElement } from 'react';
import TabsContext from '../context/tabs-context';
import TabsContentListLayout from '../components/layout/tabs-content-list-layout';
import TabsContentListSwipeableLayout from '../components/layout/tabs-content-list-swipeable-layout';

export default function TabsContentListContainer({ children }) {
  const { activeTabId, onTabChange, disableSwipeableContent, isSwipePrevented } =
    useContext(TabsContext);

  const activeTabIndex = children.findIndex(
    (child) => isValidElement(child) && child.props.tabId === activeTabId
  );

  const handleTabChange = (index, indexLatest, meta) => {
    // In some cases, the `react-swipeable-views` library works incorrectly, and set not the correct active tab index. So we need to prevent the tab change with the `focus` reason.
    if (meta.reason === 'focus') {
      return;
    }

    // It's bad practice to rely on the internal structure of children
    // Avoid such constructions and avoid such kinkd of type casting in future
    const newActiveTabId = children[index].props.tabId;
    onTabChange(newActiveTabId);
  };

  const contentSwipeable = (
    <TabsContentListSwipeableLayout
      index={activeTabIndex}
      onChangeIndex={handleTabChange}
      isSwipePrevented={isSwipePrevented}
    >
      {children}
    </TabsContentListSwipeableLayout>
  );

  const content = <TabsContentListLayout>{children}</TabsContentListLayout>;

  return disableSwipeableContent ? content : contentSwipeable;
}
